import { createLazyComponent } from '@muse-web/router'

export const AsyncAudacityDownloadDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-audacity-download' */ './AudacityDownloadDialogContainer'
        ),
    'AudacityDownloadDialogContainer',
)
